
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/photo-to-painting",
      function () {
        return require("private-next-pages/photo-to-painting/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/photo-to-painting"])
      });
    }
  